import {Component, forwardRef} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {ReportGenerationService} from "../../../framework/entity/report/report-generation.service";
import {BriefTillSummaryReportModel} from "../../reports/brief-till-summary-report/brief-till-summary-report.model";

/**
 * SearchAction to generate a stock transfer report
 */
@Component({
    selector: "wbo-brief-till-summary-report-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => BriefTillSummaryReportSearchActionComponent),
            multi: true
        },
        provideReportModel(BriefTillSummaryReportModel)
    ]
})
export class BriefTillSummaryReportSearchActionComponent implements SearchAction {

    constructor(private reportModel: BriefTillSummaryReportModel,
                private reportGenerationService: ReportGenerationService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 60;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "reports";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.cash-management.search.action.report";
    }

    async doAction(data: any): Promise<void> {
        this.reportModel.data.floatId = data["floatId"];
        await this.reportGenerationService.execute(this.reportModel);
    }

    isAvailable(data: any): boolean {
        return data.status && data.status.trim() !== "Open";
    }
}
